/*Imports*/
import React, { Fragment } from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import CoverBanner from "components/Spotlight/CoverBanner";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import FriendUserProfileBox from "components/Tribe/Friends/UserDetail/FriendUserProfileBox";
import "containers/Spotlight/MySpotlight.css";
import "components/Spotlight/Spotlight_Common.css";
import "containers/ProjectCommon.css";
import "containers/Tribe/Friends/UserDetail/PrivateUserProfile.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
import GroupDetailTabs from "./GroupDetailTabs";
import GroupListContainer from "components/Tribe/Groups/GroupsHome/GroupListContainer";
import "containers/Tribe/Groups/GroupListContainer.css";
import TextTheme from "components/General/Text/TextTheme";
import SearchNewUsers from "components/Tribe/Friends/FriendsHome/SearchNewUsers";
import FriendsSearchGrid from "components/Project/StartProject/Step_3/FriendsSearchGrid";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import Feeds from "../../../Feeds/Feeds";
import RoundedButton from "../../../../components/General/Form/CustomButton/RoundedButton";

class MemberGroupProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupDetails: this.props.groupDetails,
      groupId: this.props.groupId,
      history: this.props.history,
      phone: this.props.groupDetails.contact.split("__")[0],
      email: this.props.groupDetails.contact.split("__")[1],
      members: [],
      selectedTabIndex: 0,
      inviteList: "",
      requestList: "",
      popupSearch: false,
      groupsSearchData: [],
      searchType: "",
      searchValue: "",
      searchPage: 1,
      searchOrigin: CONSTANT.GROUPS,
      searchMoreAvailable: true,
      searchLessAvailable: true,
    };
    this.selectIndex = this.selectIndex.bind(this);
  }
  selectIndex(index) {
    this.setState({ selectedTabIndex: index });
  }

  componentDidMount() {
    const groupNumber = this.state.groupId;
    AxiosConfig.get("groups/" + groupNumber + "/members/", {
      params: { filter: "" },
    }).then((response) => {
      this.setState({ members: response.data.results });
    });

    // get a list of all pending group invites, endpoint will either return all the group invites
    // if the user is a moderator or owner, or just this user's invites if they are a member
    AxiosConfig.get(
      "groups/" + this.state.groupId + "/group-invitations/"
    ).then((response) => {
      this.setState({ inviteList: response.data });
    });

    // get a list of all recieved group requests, only for moderators or owners
    if (
      this.state.groupDetails.role === CONSTANT.MODERATOR ||
      this.state.groupDetails.role === CONSTANT.OWNER
    ) {
      AxiosConfig.get("groups/" + this.state.groupId + "/requests/").then(
        (response) => {
          this.setState({ requestList: response.data });
        }
      );
    }
  }
  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchFriendsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchGroupsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag,
      this.props.groupId
    );
  }
  onInviteFriend() {
    window.location.assign("/build-your-team/" + this.props.groupId + "/");
  }
  getMembersComponent() {
    return (
      <Fragment>
        <div className="page_details_content_main">
          <div className="mb-15 title_search_header">
            <div className="textHeader">{CONSTANT.INVITATIONS}</div>
            <div className="friend_search_container">
              <SearchNewUsers
                searchResultHandler={FriendsSearchHelper.searchResultHandler.bind(
                  this
                )}
                placeholder={CONSTANT.FIND_NEW_MEMBERS}
              />
            </div>
          </div>
          {this.state.inviteList && this.state.inviteList.length > 0 ? (
            <GroupListContainer
              groupLists={this.state.inviteList}
              type={CONSTANT.ALL_GROUP_INVITATIONS}
              role={this.props.role}
              pageSize={6}
            />
          ) : (
            <TextTheme
              message={CONSTANT.NO_NEW_GROUP_INVITATIONS}
              className="mt-15 mb-15 text_small text_med_grey text-center"
            />
          )}
          <div className="text-right invite-more">
            <RoundedButton
              title="Invite a Friend"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onInviteFriend.bind(this)}
              margin="20px 0 0 0"
              borderRadius="6px"
            />
          </div>
        </div>
        {
          // render the recieved requests contianer only if the user is an owner or moderator
          // and if the group is not public
          (this.state.groupDetails.role === CONSTANT.MODERATOR ||
            this.state.groupDetails.role === CONSTANT.OWNER) &&
          this.state.groupDetails.visibility !== CONSTANT.PUBLIC ? (
              <div className="mt-15 page_details_content_main">
                <div className="textHeader">{CONSTANT.REQUESTS}</div>
                {this.state.requestList && this.state.requestList.length > 0 ? (
                  <GroupListContainer
                    groupLists={this.state.requestList}
                    type={CONSTANT.ALL_GROUP_REQUESTS}
                    role={this.props.role}
                    pageSize={6}
                  />
                ) : (
                  <TextTheme
                    message={CONSTANT.NO_NEW_GROUP_REQUESTS}
                    className="mt-15 mb-15 text_small text_med_grey text-center"
                  />
                )}
            </div>
          ) : null
        }
        <div className="mt-15 page_details_content_main">
          <div className="textHeader">{CONSTANT.MEMBERS}</div>
          {this.state.members && this.state.members.length > 0 ? (
            <GroupListContainer
              groupLists={this.state.members}
              datePrefix={CONSTANT.MEMBER_SINCE}
              groupId={this.state.groupId}
              type={CONSTANT.MEMBER}
              userRole={this.state.groupDetails.role}
              pageSize={10}
            />
          ) : (
            <TextTheme
              message={CONSTANT.NO_MEMBERS}
              className="mt-15 mb-15 text_small text_med_grey text-center"
            />
          )}
        </div>
      </Fragment>
    );
  }
  getGroupFeeds() {
    return (
      <div className="mt-15 d-flex group-feeds">
        <Feeds isGroup={true} groupID={this.props.groupDetails.id} />
        {/* <div className="add-feeds"></div> */}
      </div>
    );
  }

  renderContainer(index) {
    switch (index) {
      case 0:
        return (
          <div className="mt-15 d-inline-block w-100">
            <h4 className="aboutMeTitle">{CONSTANT.ABOUT_US}</h4>
            <p>{this.state.groupDetails.description}</p>
            <h4 className="aboutMeTitle">{CONSTANT.GROUP_MISSION}</h4>
            <p>{this.state.groupDetails.mission}</p>
            <h4 className="aboutMeTitle">{CONSTANT.WE_SUPPORT}</h4>
            {/*<p>{this.state.groupDetails.support}</p>*/}
            <ul>
              {this.state.groupDetails.project_interest &&
              this.state.groupDetails.project_interest.length > 0 ? (
                this.state.groupDetails.project_interest.map((elem, index) => (
                  <li key={index}>{elem}</li>
                ))
              ) : (
                <div></div>
              )}
            </ul>
            <h4 className="aboutMeTitle">{CONSTANT.OUR_FAVORITE_CAUSES}</h4>
            <p>{this.state.groupDetails.causes}</p>
            <h4 className="aboutMeTitle">{CONSTANT.WEBSITE}</h4>
            <a
              href={this.state.groupDetails.website}
              target="_blank"
              style={{ marginBottom: "15px" }}
            >
              {this.state.groupDetails.website}
            </a>
            <h4 className="aboutMeTitle">{CONSTANT.CONTACT_INFO}</h4>
            <div>{this.state.phone}</div>
            <a href={"mailto:" + this.state.email}>{this.state.email}</a>
            <br />
          </div>
        );
      case 1:
        return this.getGroupFeeds();

      case 2:
        return (
          <div style={{ textAlign: "center" }}>
            <TextTheme
              message={CONSTANT.IMPACT_SOON}
              className="mt-15 text_medium text_med_grey text_bold"
            />
          </div>
        );
      case 3:
        return this.getMembersComponent();
      case 4:
        return (
          <div style={{ textAlign: "center" }}>
            <TextTheme
              message={CONSTANT.ALBUM_SOON}
              className="mt-15 text_medium text_med_grey text_bold"
            />
          </div>
        );
    }
  }

  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchGroupsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchGroupsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag,
      this.props.groupId
    );
  }

  render() {
    const location = this.state.groupDetails.location;
    
    const street = location?.split("__")[0]?.trim();
    const city = location?.split("__")[1]?.trim();
    const stateUS = location?.split("__")[2]?.trim();
    const zip = location?.split("__")[3]?.trim();
    let locationDetails = street + "__" + city + ", " + stateUS + ", " + zip;
    return (
      <div className="header_main main_possible_friend">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="main_pane">
            <div className="cover_photo">
              <div className="padding_above_cover"></div>
              <CoverBanner
                cover={this.state.groupDetails.cover_pic || MyDefaultCoverPhoto}
                profile={this.state.groupDetails.group_pic}
              />
              <div className="padding_between"></div>
            </div>
            <div className="user_details">
              <FriendUserProfileBox
                full_name={this.state.groupDetails.name}
                type={CONSTANT.GROUPS}
                // location={this.state.groupDetails.location}
                location={locationDetails}
                profilePic={this.state.groupDetails.group_pic}
                time={this.state.groupDetails.created_at}
                groupUser={this.state.groupDetails.username}
                groupId={this.state.groupDetails.id}
                role={this.props.role}
              />
              <GroupDetailTabs
                options={["About Us", "News", "Impact", "Members", "Album"]}
                selectedTabIndex={this.state.selectedTabIndex}
                handleOnClick={this.selectIndex}
              ></GroupDetailTabs>
              {this.renderContainer(this.state.selectedTabIndex)}
            </div>
            {this.state.popupSearch ? (
              <FriendsSearchGrid
                searchData={this.state.groupsSearchData}
                searchStringType={this.state.searchType}
                searchStringValue={this.state.searchValue}
                searchMore={this.state.searchMoreAvailable}
                searchLess={this.state.searchLessAvailable}
                searchResultCancelClick={FriendsSearchHelper.searchResultCancelClick.bind(
                  this
                )}
                searchResultDoneClick={FriendsSearchHelper.searchResultDoneClick.bind(
                  this
                )}
                searchResultNextClick={FriendsSearchHelper.searchResultNextClick.bind(
                  this
                )}
                searchResultBackClick={FriendsSearchHelper.searchResultBackClick.bind(
                  this
                )}
                searchResultViewClick={FriendsSearchHelper.searchResultViewClick.bind(
                  this
                )}
                groupName={this.props.groupDetails.name}
                groupID={this.state.groupId}
              />
            ) : null}{" "}
          </div>
        </div>
      </div>
    );
  }
}

export default MemberGroupProfile;
